/**
 * Mobile Sticky Add-to-Cart Button
 * Always visible at bottom on mobile
 */

class MobileStickyATC {
  constructor() {
    this.isMobile = window.matchMedia('(max-width: 767px)');
    this.stickyBar = null;
    this.originalButton = null;

    this.init();
  }

  init() {
    // Only initialize on mobile
    if (!this.isMobile.matches) return;

    // Find the mobile buy button container
    this.originalButton = document.querySelector('.mobile-only [id^="buy-buttons-"]');
    if (!this.originalButton) return;

    this.createStickyBar();
    this.handleResize();
  }

  createStickyBar() {
    // Clone the original button container
    const clone = this.originalButton.cloneNode(true);

    // Create sticky bar wrapper
    this.stickyBar = document.createElement('div');
    this.stickyBar.className = 'mobile-sticky-atc-bar';

    // Update cloned form ID to prevent duplicate ID conflicts
    const clonedForm = clone.querySelector('form');
    if (clonedForm) {
      const originalFormId = clonedForm.id;
      clonedForm.id = originalFormId + '-sticky';
      this.syncFormWithOriginal(clonedForm);
    }

    // Keep the original block ID to preserve CSS styles (original is hidden anyway)

    this.stickyBar.appendChild(clone);
    document.body.appendChild(this.stickyBar);

    // Show immediately and add body class for padding
    document.body.classList.add('mobile-sticky-active');

    // Listen for variant changes to sync
    this.setupVariantSync();
  }

  syncFormWithOriginal(clonedForm) {
    const originalForm = this.originalButton.querySelector('form');
    if (!originalForm) return;

    const originalVariantInput = originalForm.querySelector('input[name="id"]');
    const clonedVariantInput = clonedForm.querySelector('input[name="id"]');

    if (originalVariantInput && clonedVariantInput) {
      clonedVariantInput.value = originalVariantInput.value;
    }
  }

  setupVariantSync() {
    // Listen for variant changes
    document.addEventListener('variant:changed', (e) => {
      this.updateStickyVariant(e.detail?.variant);
    });

    // Poll for changes (fallback)
    const originalForm = this.originalButton.querySelector('form');
    const stickyForm = this.stickyBar?.querySelector('form');

    if (!originalForm || !stickyForm) return;

    const originalInput = originalForm.querySelector('input[name="id"]');
    const stickyInput = stickyForm.querySelector('input[name="id"]');

    if (!originalInput || !stickyInput) return;

    setInterval(() => {
      if (originalInput.value !== stickyInput.value) {
        stickyInput.value = originalInput.value;
      }
    }, 100);
  }

  updateStickyVariant(variant) {
    if (!variant || !this.stickyBar) return;

    const stickyForm = this.stickyBar.querySelector('form');
    if (stickyForm) {
      const variantInput = stickyForm.querySelector('input[name="id"]');
      if (variantInput && variant.id) {
        variantInput.value = variant.id;
      }
    }
  }

  handleResize() {
    this.isMobile.addEventListener('change', (e) => {
      if (e.matches) {
        if (!this.stickyBar) {
          this.init();
        }
      } else {
        this.cleanup();
      }
    });
  }

  cleanup() {
    if (this.stickyBar) {
      this.stickyBar.remove();
      this.stickyBar = null;
    }
    document.body.classList.remove('mobile-sticky-active');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MobileStickyATC());
} else {
  new MobileStickyATC();
}
